import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ChevronUp, ChevronDown, Eye, EyeOff } from "lucide-react";

export const AVAILABLE_WIDGETS = [
  { id: "kpis", label: "Cartes KPI" },
  { id: "warranty", label: "Désordres par famille de garantie" },
  { id: "priority", label: "Actions prioritaires" },
  { id: "status", label: "Désordres par statut" },
  { id: "risk", label: "Actifs à risque" },
  { id: "activity", label: "Activité récente" },
  { id: "compare", label: "Comparateur temporel" },
  { id: "timeline", label: "Statistiques 12 mois" },
];

export default function DashboardCustomizer({ open, onClose, value, onChange }) {
  const move = (idx, dir) => {
    const next = [...value];
    const swap = idx + dir;
    if (swap < 0 || swap >= next.length) return;
    [next[idx], next[swap]] = [next[swap], next[idx]];
    onChange(next);
  };
  const toggle = (id) => {
    onChange(value.map((w) => (w.id === id ? { ...w, visible: !w.visible } : w)));
  };
  const reset = () => onChange(AVAILABLE_WIDGETS.map((w) => ({ ...w, visible: true })));

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader><DialogTitle>Personnaliser le tableau de bord</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500 -mt-2 mb-2">Masquez, affichez et réorganisez les widgets. La configuration est enregistrée pour votre compte.</p>
        <div className="space-y-1 max-h-96 overflow-y-auto" data-testid="widget-list">
          {value.map((w, idx) => (
            <div key={w.id} data-testid={`widget-${w.id}`} className="flex items-center gap-2 border border-slate-200 rounded-lg p-2 bg-white">
              <div className="flex flex-col">
                <button data-testid={`widget-up-${w.id}`} onClick={() => move(idx, -1)} disabled={idx === 0} className="p-0.5 rounded hover:bg-slate-100 disabled:opacity-30"><ChevronUp size={12} /></button>
                <button data-testid={`widget-down-${w.id}`} onClick={() => move(idx, 1)} disabled={idx === value.length - 1} className="p-0.5 rounded hover:bg-slate-100 disabled:opacity-30"><ChevronDown size={12} /></button>
              </div>
              <div className="flex-1 text-sm font-medium">{w.label}</div>
              <button
                data-testid={`widget-toggle-${w.id}`}
                onClick={() => toggle(w.id)}
                className={`p-1.5 rounded-md transition ${w.visible ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-100" : "bg-slate-100 text-slate-400 hover:bg-slate-200"}`}
                title={w.visible ? "Masquer" : "Afficher"}
              >{w.visible ? <Eye size={14} /> : <EyeOff size={14} />}</button>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={reset} data-testid="widget-reset">Réinitialiser</Button>
          <Button className="text-white" style={{ background: "#023E73" }} onClick={onClose}>Terminé</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
